export default __webpack_public_path__ + "static/media/checkbox.1d1f0eb8.svg";